// Why is this necessary?
var $modalElement;
$(function () {
    $modalElement = $('#submissioninprogress');
});

jQuery(function ($) {
    var validJquery = function (el) {
        return (typeof el.validate == 'undefined' || typeof el.validate() == 'undefined' || el.validate().valid());
    }

    var validParsley = function (el) {
        var validator = el.parsley;
        return (typeof validator == 'undefined' || el.parsley().validationResult);
    }

    $(document).on('submit', 'form.customform', function () {
        var $form = $(this);
        if (validJquery($form) && validParsley($form)) {
            setTimeout(function () {
                $modalElement.modal('show');
            },
                800);
        }
        return true;
    });
});
